import { FormattedMessage } from "react-intl";

import { ScenarioReview } from "@nens/ldo/api-v1";

export function FieldDescription({ field }: { field: keyof ScenarioReview }) {
  if (field === "content_quality") {
    return <FormattedMessage id="qc.field.content_quality" defaultMessage="Content Quality" />;
  } else if (field === "data_valid") {
    return <FormattedMessage id="qc.field.data_valid" defaultMessage="Data Valid" />;
  } else if (field === "metadata_complete") {
    return <FormattedMessage id="qc.field.metadata_complete" defaultMessage="Metadata Complete" />;
  } else if (field === "metadata_valid") {
    return <FormattedMessage id="qc.field.metadata_valid" defaultMessage="Metadata Valid" />;
  }
  return null;
}
